<template>
  <ValidationProvider
    v-slot="{ errors, validated }"
    :name="$props.name || $props.label"
    :rules="$props.rules"
    class="base-select"
    :class="{ 'displayflex': displayType == 'displayflex' }"
    :immediate="false"
    tag="div"
  >
    <label v-if="!!$props.label || $slots.label" :for="id" :class="{ 'labelWidth': displayType == 'displayflex' }">
      <slot name="label">{{ $props.label }}</slot>
    </label>
    <div>
    <b-form-select
      v-model="modelValue"
      v-bind="$attrs"
      v-on="$listeners"
      :name="$props.name"
      :class="{ 'is-invalid': !!errors.length,
                'dropdownWidth': displayType == 'displayflex', 
                'dropdownWidth-sm': displayType == 'dropdownWidth-sm',
                'dropdownWidth-md': displayType == 'dropdownWidth-md' 
      }"      
    >
      <template v-slot:first>
        <slot name="first" />
      </template>
    </b-form-select>
  </div>

    <div v-if="validated && !!errors.length" class="invalid-feedback d-block">{{ errors[0] }}</div>
  </ValidationProvider>
</template>

<script>
import { defineComponent, computed } from '@vue/composition-api'
import { uniqueId } from 'lodash-es'
import { ValidationProvider } from 'vee-validate'

export default defineComponent({
  name: 'BaseSelect',
  inheritAttrs: false,
  components: {
    ValidationProvider
  },
  props: {
    name: String,
    value: [String, Number, Boolean],
    label: String,
    rules: String,
    displayType: String
  },
  emits: ['input'],
  setup(props, { emit }) {
    const id = computed(() => `id_${uniqueId('base-select-')}`)

    const modelValue = computed({
      get: () => props.value,
      set: (newValue) => emit('input', newValue)
    })

    return {
      id,
      modelValue
    }
  }
})
</script>
<style scoped>
.displayflex {
  display: flex !important;
}
.labelWidth {
  width: 50%;  
}
.dropdownWidth {
  width: 30%;
  margin-left: 20px;
}
.dropdownWidth-sm {
  width: 30%;
}
.dropdownWidth-md {
  width: 50%;
}
</style>
